export const HARMONY_DEVELOPMENT_SITE_TEMPLATE_ID =
  '91532250-8835-46ac-9666-e4db8770b275';

export function getAppInstallUrl({
  appId,
  siteId,
}: {
  appId: string;
  siteId: string;
}) {
  return `https://manage.wix.com/installer/install?metaSiteId=${siteId}&appId=${appId}&platform=cli&version=latest`;
}
